import './Navbar.css';
import React, {useState, useEffect} from 'react';
import { ReactComponent as IconUser } from '../Img/icon-user.svg';
import { ReactComponent as IconAPI } from '../Img/icon-API.svg';
import { ReactComponent as Restitutions } from '../Img/icon-restitutions.svg';
import { ReactComponent as Database } from '../Img/icon-database.svg';
import { ReactComponent as Organismes } from '../Img/icon-organismes.svg';
import { ReactComponent as IconMail } from '../Img/icon-mail.svg';
import { useHistory } from 'react-router-dom';


const NavbarAdmin = () =>
{
    let history = useHistory();

    const purple = '#6571FE';
    const greyChapter = '#DBDBDB';
    
        
    useEffect(() => {
    }, [])
    

	return (
        <div className='shadow-md' style={{flex: 1, backgroundColor: 'white', marginTop: 0.5, display: 'flex', minHeight: 65}}>

            {/* Bouton Gestion de la table Application */}
            <button
            style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClick={() => {
                window.location = window.location.origin + '/parametre/application'
            }}
            >
                <IconAPI width="20px" />
                <p style={{flex: 1, marginLeft: 10}}>Application</p>
            </button>

            {/* Bouton Gestion des Organismes */}
            <button
            style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClick={() => {
                window.location = window.location.origin + '/parametre/organismes'
            }}
            >
                <Organismes width="20px" />
                <p style={{flex: 1, marginLeft: 10}}>Organismes</p>
            </button>

            {/* Bouton Gestion des utilisateurs */}
            <button
            style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClick={() => {
                window.location = window.location.origin + '/parametre/utilisateurs'
            }}
            >
                <IconUser width="20px" />
                <p style={{flex: 1, marginLeft: 10}}>Utilisateurs</p>
            </button>

            {/* Bouton Gestion des Restitutions */}
            <button
            style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClick={() => {
                window.location = window.location.origin + '/parametre/restitutions'
            }}
            >
                <Restitutions width="20px" />
                <p style={{flex: 1, marginLeft: 10}}>Restitutions</p>
            </button>

            {/* Bouton Gestion des Nomenclatures */}
            <button
            style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClick={() => {
                window.location = window.location.origin + '/parametre/nomenclature'
            }}
            >
                <Database width="20px" />
                <p style={{flex: 1, marginLeft: 10}}>Nomenclature</p>
            </button>

            {/* Bouton envoi de mail aux utilisateurs */}
            <button
            style={{marginLeft: 20, display: 'flex', alignItems: 'center', justifyContent: 'center'}}
            onClick={() => {
                window.location = window.location.origin + '/parametre/envoi-mail-utilisateurs'
            }}
            >
                <IconMail width="20px" />
                <p style={{flex: 1, marginLeft: 10}}>Envoi Mail Utilisateurs</p>
            </button>

            <div style={{flex: 1}}></div>

        </div>
	);
}

export default NavbarAdmin;
